const CODING_AGENT_TOOL = 'mcp__subagent__create_coding_agent';
const SUBAGENT_TOOLS = new Set([
  'mcp__subagent__create_subagent',
  CODING_AGENT_TOOL,
]);

export const isSubagentTool = (tool: string): boolean =>
  SUBAGENT_TOOLS.has(tool);

export const isCodingAgentTool = (tool: string): boolean =>
  tool === CODING_AGENT_TOOL;

export const getSubagentFallbackLabel = (tool: string): string =>
  isCodingAgentTool(tool) ? 'Start coding session' : 'Start subagent';

const CHILD_CHAT_NAME_RE = /^(projects\/[^/]+\/)?chats\/[^/\s]+$/;
const AGENT_SESSION_PREFIX = 'Agent session: ';

export const parseChildChatName = (
  content: string | null | undefined,
): string | null => {
  if (!content) return null;
  const lines = content.trim().split(/\r?\n/);
  if (lines.length > 2) return null;

  const [childChatName, agentSessionLine] = lines;
  if (!CHILD_CHAT_NAME_RE.test(childChatName)) return null;
  if (!agentSessionLine) return childChatName;
  if (!agentSessionLine.startsWith(AGENT_SESSION_PREFIX)) return null;

  try {
    const agentSessionUrl = new URL(
      agentSessionLine.slice(AGENT_SESSION_PREFIX.length),
    );
    if (!agentSessionUrl.protocol) return null;
  } catch {
    return null;
  }

  return childChatName;
};
